import { Model } from "@type-r/models";

export abstract class CountsModel extends Model {
    static attributes = {
        total: Number,
        passValidationNewAsset: Number,
        passValidationModifiedAsset: Number,
        requireReview: Number,
        duplicated: Number,
        conflict: Number,
        savedForLater: Number,
        digitized: Number,
        modifyExistingAssets: Number,
    };

}
